import moment from 'moment';
import { redirect } from 'react-router-dom';
import padEnd from 'lodash/padEnd';
import * as type from './constants';
import placeholder from './placeholder.jpg';
import ClaroUrlBuilder from '../../../utils/ClaroUrlBuilder';
import { GetRegion } from '../../../constants';

export const canIGetRecommendations = (props, nextProps) =>
  nextProps.metadata !== props.metadata ||
  props.params.id !== nextProps.params.id;

export const getTitleWithYear = (titlePrincipal, publishYear) => {
  let title = `${titlePrincipal} `;
  if (publishYear !== null) {
    title += `(${publishYear})`;
  }
  return title;
};

export const hasChannelTimeShift = function(timeShift = '') {
  let ts = 0;
  if (timeShift !== null) {
    ts = parseInt(timeShift, 10);
  }
  return !isNaN(ts) && ts > 0;
};

export const isPlayButtonVisible = function(currentType = '') {
  return (
    currentType === type.EVENT_LIVE_WITH_OUT_TIME_SHIFT_START_OVER ||
    currentType === type.EVENT_PAST_WITH_TIME_SHIFT ||
    currentType === type.EVENT_LIVE_WITH_TIME_SHIFT_START_OVER ||
    currentType === type.EVENT_LIVE_NOW
  );
};

export const canRecordEvent = function(event = {}, ts = {}, channel = {}) {
  if (
    Object.keys(event).length === 0 ||
    event.currentType === type.EVENT_NO_TYPE ||
    event.currentType === type.EVENT_WITH_NO_TIME_SHIFT ||
    event.date_begin === undefined
  ) {
    return false;
  }

  const tsUserBegin = moment().subtract(ts.user, type.EVENT_MANIPULATE_KEY_EPG);
  const dateBegin = moment(event.date_begin);

  try {
    if (tsUserBegin.isAfter(dateBegin)) {
      throw Error(type.EVENT_CARD_ERROR_RECORD_RULE);
    }

    return true;
  } catch (err) {
    console.error(type.EVENT_CARD_ERROR_RECORD_RULE, err);
    return false;
  }
};

export const isInTimeShift = function(event = {}, ts = {}, channel = {}) {
  /**
   1. Que el horario del evento que será solicitado esté dentro del tiempo de timeshift disponible para el canal de acuerdo a la hora actual channels[n].group.common.timeshift
   3. Que el horario del evento que será solicitado esté dentro del tiempo de timeshift este dentro del horario permitido para el usaurio de acuerdo a la hora actual paqs.paqs[m]
   */

  if (
    Object.keys(event).length === 0 ||
    event.currentType === type.EVENT_NO_TYPE
  ) {
    return false;
  }

  const tsChannelBegin = moment().subtract(
    ts.channel,
    type.EVENT_MANIPULATE_KEY_LINEAL_CHANNELS,
  );
  const tsChannelEnd = moment().add(
    ts.channel,
    type.EVENT_MANIPULATE_KEY_LINEAL_CHANNELS,
  );

  const tsUserBegin = moment().subtract(ts.user, type.EVENT_MANIPULATE_KEY_EPG);
  const tsUserEnd = moment().add(ts.user, type.EVENT_MANIPULATE_KEY_EPG);

  const dateEnd = moment(event.date_end);

  try {
    if (!dateEnd.isBetween(tsUserBegin, tsUserEnd)) {
      throw Error(type.EVENT_CARD_ERROR_RULE_ONE_NOT_ALLOWED);
    }

    if (!dateEnd.isBetween(tsChannelBegin, tsChannelEnd)) {
      throw Error(type.EVENT_CARD_ERROR_RULE_THREE_NOT_ALLOWED);
    }

    return true;
  } catch (err) {
    console.error(type.EVENT_CARD_ERROR_RULES_NOT_ALLOWED, err);
    return false;
  }
};

/**
 *
 * @param event
 * @param hasTimeShift. Se obtiene de las 4 reglas en canIStartOver()
 */
export const getEventType = function(
  event,
  canIStartover,
  canIPlayPaq,
  isInTimeshift,
  hasTimeShift,
) {
  const dateBegin = moment(event.date_begin);
  const dateEnd = moment(event.date_end);

  if (!event.date_begin || !event.date_end) {
    return type.EVENT_NO_TYPE;
  }

  if (moment().isBefore(dateBegin)) {
    return type.EVENT_FUTURE;
  }

  if (!hasTimeShift) {
    return type.EVENT_WITH_NO_TIME_SHIFT;
  }

  if (!isInTimeShift) {
    return type.EVENT_OUT_OF_TIMESHIFT;
  }

  if (moment().isBetween(dateBegin, dateEnd) && !canIPlayPaq) {
    return type.EVENT_LIVE_WITH_OUT_TIME_SHIFT_START_OVER;
  }

  if (moment().isBetween(dateBegin, dateEnd) && canIPlayPaq) {
    return type.EVENT_LIVE_WITH_TIME_SHIFT_START_OVER;
  }

  if (moment().isBetween(dateBegin, dateEnd)) {
    return type.EVENT_LIVE_NOW;
  }

  if (!canIStartover || !canIPlayPaq) {
    return type.EVENT_PAST_WHITOUT_PLAY_PERMISSIONS;
  }

  if (moment().isAfter(dateEnd) && !isInTimeshift) {
    return type.EVENT_PAST_WITH_OUT_TIME_SHIFT;
  }

  if (moment().isAfter(dateEnd) && isInTimeshift) {
    return type.EVENT_PAST_WITH_TIME_SHIFT;
  }
  return type.EVENT_NO_TYPE;
};

export const getEvent = channel => {
  let event;

  if (channel) {
    event = channel.events[0];
  }

  return event;
};

export const getImageEvent = function(data) {
  const src = [];

  const addSrc = urlSrc => {
    if (typeof urlSrc === 'string' && urlSrc.length > 0) {
      src.push(urlSrc);
    }
  };

  if (data.landscape) {
    addSrc(data.event && data.event.ext_eventimage_name);
    addSrc(data.contentData && data.contentData.image_large);
    addSrc(placeholder);
  } else {
    addSrc(data.contentData && data.contentData.image_medium);
    addSrc(placeholder);
  }
  return src;
};

export const notAllowed = () => {
  redirect(`/${GetRegion()}/tv`);
};

export const goToPlayer = function({
  region,
  urlPlayer,
  groupId,
  startTime,
  endTime,
  token,
  safeTime,
  isOLDExperience,
}) {
  let url = ClaroUrlBuilder.player(groupId);

  if (!isOLDExperience) {
    url += '&guidechannel&noModal';
  }

  let d = new Date(startTime);
  d.setSeconds(d.getSeconds() + safeTime.start);
  const st = padEnd(`${d.getTime()}`, 17, '0');
  d = new Date(endTime);
  d.setSeconds(d.getSeconds() + safeTime.end);
  const et = padEnd(`${d.getTime()}`, 17, '0');

  url += `&startTime=${st}&endTime=${et}&is_live&assets=${token}`;
  window.location = url;
};
